import React, {useState} from 'react';
import '../css/services.css';
import { sendEmail } from './api';
import PageHeader from './PageHeader';

const Services = () => {

  const [showForm, setShowForm] = useState(false); // State to control form visibility
  const [formData, setFormData] = useState({  // State to store form data
    name: '',
    phone:'',
    email: '',
    message: '',
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleButtonClick = (service) => {
    setShowForm(true); // Show the form when the button is clicked
    setFormSubmitted(false); // Reset the form submitted state
    setFormData({ name: '',phone:'', email: '', message: '' }); //clear the form
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {e.preventDefault();


    /**can have validations here later */


    try {
      const response = await sendEmail(formData); // Call the EmailJS-integrated function
      alert('Email sent successfully!', response);
      setShowForm(false);
      setFormSubmitted(true);
      setFormData({ name: '', email: '', phone: '', message: '' }); // Clear the form completely
     } catch (error) {
        console.error('Error sending email:', error);
        alert("A network error occurred. Please try again later."); // Network error
    }
};



  return (
    <div>
      <PageHeader eyebrow="Services" title="AI and web solutions, built around you">
        From intelligent agents to modern websites, we design, build and support technology that fits the way your business works.
      </PageHeader>

      <div className="page section">
        {/* AI Agents Section */}
        <article id="aiagent" className="feature">
          <div className="feature-media">
            <img
              src={`${process.env.PUBLIC_URL}/images/AI_Agent.png`}
              alt="AI Agents"
            />
          </div>
          <div className="feature-body">
            <h2>Revolutionize Your Workflow with AI Agents</h2>
            <p>
              Harness the power of cutting-edge AI to simplify your daily tasks. Our AI Agents are intelligent, adaptable, and designed to act as your personal assistants. Whether it’s curating a personalized workout plan, managing your diet, or planning your next vacation within budget, our agents are here to make your life easier. Built on the latest Large Language Models (LLMs), our AI Agents deliver smart, efficient, and reliable solutions tailored to your needs.
            </p>
            <ul className="feature-list">
              <li>Personalized Assistance</li>
              <li>Efficient Workflow</li>
              <li>Smart Decision-Making</li>
              <li>24/7 Availability</li>
            </ul>
            <button className="btn" onClick={() => handleButtonClick('aiagent')}>Get Started with AI Agents</button>
          </div>
        </article>

        {/* Website Designing Section */}
        <article id="webdev" className="feature feature--reverse">
          <div className="feature-media">
            <img
              src={`${process.env.PUBLIC_URL}/images/web_development.png`}
              alt="Website Designing"
            />
          </div>
          <div className="feature-body">
            <h2>Build Your Digital Presence with Stunning Websites</h2>
            <p>
              In today’s digital age, a professional website is essential for scaling your business. Our team of expert designers and engineers creates elegant, user-friendly websites that not only look great but also perform seamlessly. From secure, scalable architectures to intuitive user interfaces, we bring your vision to life. Don’t worry if you’re not tech-savvy—our customer relationship managers will work closely with you to understand your needs and deliver a solution that exceeds your expectations.
            </p>
            <ul className="feature-list">
              <li>Custom Designs</li>
              <li>Scalable Solutions</li>
              <li>Security First</li>
              <li>End-to-End Support</li>
            </ul>
            <button className="btn" onClick={() => handleButtonClick('webdev')}>Request a Website Quote</button>
          </div>
        </article>
      </div>

      {/* The Form */}
      {showForm && ( // Conditionally render the form
        <div className="form-overlay" onClick={() => setShowForm(false)}> {/* Overlay to dim the background */}
          <div className="form-container" role="dialog" aria-modal="true" aria-labelledby="service-form-title" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="form-close" aria-label="Close" onClick={() => setShowForm(false)}>×</button>
            <h2 id="service-form-title">Get in Touch</h2>
            <p className="form-intro">Tell us a little about what you need and we'll get back to you.</p>
            {formSubmitted && <p className="success-message">Thank you for your request! We'll be in touch soon.</p>}
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleInputChange}
                required
              />
              <div className="form-actions">
                <button type="button" className="btn btn-outline" onClick={() => setShowForm(false)}>Close</button>
                <button type="submit" className="btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
